import CellHOC from '@platform/react/hoc/list/cell'
import LabeledHOC from '@platform/react/hoc/list/labeled'
import { ListItemCellTicketType } from 'ui/Element/List/Item/Cell/Ticket/Type'

export default CellHOC(
  LabeledHOC(
    props => props.number || '-', ListItemCellTicketType,
  ),
)
